import {Icon, Label} from 'pepsico-ds'
import sharedStyles from '@/components/SelfOnboarding/Shared/OnboardingFormShared.module.css'
import inputStyles from './CustomInput.module.css'

interface CustomInputProps {
  isDark?: boolean
  inputSize?: string
  name: string
  label: string
  value: string
  placeholder?: string
  error?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  helperText?: string
  type?: string
  customContainerClass?: string
  inputRowClass?: string
  inputClass?: string
}

/**
 * A container component for displaying KPIs and other card-based content
 */
const CustomInput: React.FC<CustomInputProps> = ({
  isDark,
  inputSize,
  name,
  label,
  value,
  placeholder,
  error,
  onChange,
  onBlur,
  helperText,
  type,
  customContainerClass,
  inputClass,
  inputRowClass,
}) => {
  return (
    <div className={inputStyles.inputWrapper}>
      <Label label={label} className={sharedStyles.autocompleteLabelFont} htmlFor={name} />
      <div
        data-testid="kpi-container"
        className={`${inputRowClass ? inputRowClass : sharedStyles.onboardingInputRow} ${inputStyles.inputContainer}`}
      >
        <input
          id={name}
          type={type || 'text'}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          className={`${inputClass ? inputClass : sharedStyles.onboardingInput} ${inputStyles.inputText}`}
        />
      </div>
      {error && <Label className={`${inputStyles.errorLabel}`} label={error} />}
      {helperText && !error && (
        <div className="flex-start flex w-[282px] text-[var(--color-text-secondary)]">
          <Icon icon="info" size="small" style={{marginRight: '0.25rem'}} />{' '}
          <Label className={sharedStyles.helperMessage} label={helperText} />
        </div>
      )}
    </div>
  )
}

export default CustomInput
